import * as THREE from 'three';

export class PaperPlane {
  readonly mesh: THREE.Mesh;
  readonly velocity = new THREE.Vector3();
  readonly trailPositions: THREE.Vector3[] = [];
  private trailLine: THREE.Line | null = null;
  private trailGeo: THREE.BufferGeometry | null = null;
  private trailLimit = 24;

  constructor() {
    const geo = new THREE.BufferGeometry();
    const v = new Float32Array([
      0,    0,    0.9,
     -0.5,  0,   -0.6,
      0.5,  0,   -0.6,
      0,    0.18, -0.4
    ]);
    const idx = [
      0, 1, 3,
      0, 3, 2,
      0, 2, 1,
      1, 2, 3
    ];
    geo.setAttribute('position', new THREE.BufferAttribute(v, 3));
    geo.setIndex(idx);
    geo.computeVertexNormals();
    const mat = new THREE.MeshStandardMaterial({ color: 0xfdfaf0, flatShading: true, side: THREE.DoubleSide });
    this.mesh = new THREE.Mesh(geo, mat);
    this.mesh.scale.set(1.2, 1.2, 1.2);
  }

  attachTrail(scene: THREE.Scene): void {
    this.trailGeo = new THREE.BufferGeometry();
    const positions = new Float32Array(this.trailLimit * 3);
    this.trailGeo.setAttribute('position', new THREE.BufferAttribute(positions, 3));
    this.trailGeo.setDrawRange(0, 0);
    const mat = new THREE.LineBasicMaterial({ color: 0xfff5d0, transparent: true, opacity: 0.7 });
    this.trailLine = new THREE.Line(this.trailGeo, mat);
    scene.add(this.trailLine);
  }

  resetTrail(): void {
    this.trailPositions.length = 0;
    if (this.trailGeo) {
      this.trailGeo.setDrawRange(0, 0);
      this.trailGeo.attributes.position.needsUpdate = true;
    }
  }

  pushTrail(p: THREE.Vector3): void {
    this.trailPositions.push(p.clone());
    if (this.trailPositions.length > this.trailLimit) this.trailPositions.shift();
    if (!this.trailGeo) return;
    const arr = this.trailGeo.attributes.position.array as Float32Array;
    for (let i = 0; i < this.trailPositions.length; i++) {
      const tp = this.trailPositions[i];
      arr[i * 3 + 0] = tp.x;
      arr[i * 3 + 1] = tp.y;
      arr[i * 3 + 2] = tp.z;
    }
    this.trailGeo.setDrawRange(0, this.trailPositions.length);
    this.trailGeo.attributes.position.needsUpdate = true;
  }

  setHidden(hidden: boolean): void {
    this.mesh.visible = !hidden;
    if (this.trailLine) this.trailLine.visible = !hidden;
  }
}
